import React, { ReactNode, lazy, useState } from 'react';
import ModalContext, { ModalDataProp } from './modalContext';

interface ModalProviderProps {
  children: React.ReactNode;
}

type ModalTypes =
  | 'updateKyc'
  | 'disableTwoFactor'
  | 'debitUser'
  | 'manageWithdrawal'
  | 'buyRate'
  | 'sellRate'
  | '';

const UpdateKycLevel = lazy(
  () => import('../../components/dashboard/Users/components/UpdateKyc')
);
const DisableTwoFactor = lazy(
  () => import('../../components/dashboard/Users/components/DisableTwoFactor')
);
const DebitUser = lazy(
  () => import('../../components/dashboard/Users/components/DebitUser')
);
const ManageWithdrawal = lazy(
  () => import('../../components/dashboard/Users/components/ManageWithdrawal')
);

const BuyRate = lazy(
  () => import('../../components/dashboard/Settings/components/BuyRate')
);
const SellRate = lazy(
  () => import('../../components/dashboard/Settings/components/SellRate')
);

const ModalProvider = ({ children }: ModalProviderProps) => {
  const getModal = (modal: ModalTypes): ReactNode => {
    switch (modal) {
      case 'updateKyc':
        return <UpdateKycLevel />;

      case 'disableTwoFactor':
        return <DisableTwoFactor />;

      case 'debitUser':
        return <DebitUser />;

      case 'manageWithdrawal':
        return <ManageWithdrawal />;

      case 'buyRate':
        return <BuyRate />;

      case 'sellRate':
        return <SellRate />;

      default:
        return <></>;
    }
  };

  const [modal, setModal] = useState<ModalDataProp>({
    modal: '',
    metadata: {},
  });
  const [openModal, setOpenModal] = useState<boolean>(false);
  const modalComponent = getModal(modal?.modal as ModalTypes);

  return (
    <ModalContext.Provider
      value={{
        openModal,
        setOpenModal,
        modal,
        setModal,
        modalComponent,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
